import React from 'react';
import SmallRedButton from '@components/common/button/SmallRedButton';
import { useState } from 'react';
import EnumField from '../../../../../common/form/formik/input/EnumField';
import LabeledField from '../../../../../common/form/formik/input/LabeledField';
import FoldAnimation from './animation/FoldAnimation';
import DynamicChevron from './icons/DynamicChevron';
import { DayOfTheWeek } from '@data/course/courseData';

interface MeetingInfoProps {
  sectionIndex: number;
  meetingIndex: number;
  removeSelf: (index: number) => void | undefined;
  canRemove: boolean;
}

const MeetingInfo = ({ sectionIndex, meetingIndex, removeSelf, canRemove }: MeetingInfoProps) => {
  const meetingDataLocation = `sections[${sectionIndex}].meetings[${meetingIndex}]`;
  const dayLocation = meetingDataLocation + '.day';
  const timeLocation = meetingDataLocation + '.time';

  const [folded, setFolded] = useState(false);

  return (
    <>
      <div className='flex flex-row items-center'>
        <p className='text-xl'>Meeting {meetingIndex + 1}</p>
        <div className='ml-auto'>
          <DynamicChevron onChange={() => setFolded((f) => !f)} folded={folded} />
        </div>
      </div>
      <FoldAnimation folded={folded}>
        <div className='ml-8 children-spaced'>
          <EnumField label='Meeting Day' name={dayLocation} enumToUse={DayOfTheWeek} />
          {/* Time input guarantees hh:mm */}
          <LabeledField label='Meeting Time' type='time' name={timeLocation} />
        </div>
        <SmallRedButton
          text='REMOVE MEETING'
          onClick={() => removeSelf(meetingIndex)}
          clickable={canRemove}
        />
      </FoldAnimation>
    </>
  );
};

export default MeetingInfo;
